import { Injectable } from "@angular/core";
import * as signalR from '@aspnet/signalr';
import { HubConnection } from '@aspnet/signalr';
import { Subject } from "rxjs";
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { StorageVariable } from "../shared/object/local-storage-variable.enum";

export class SignalRConnectionInfo {
  url: string;
  accessKey: string;
  userId: string;
  idToken: string;
}

@Injectable()
export class SignalRService {
  private hubConnection: HubConnection;
  messages: Subject<string> = new Subject();
  private rutEmpresa: number;
  private produccion: boolean = true; //Determina el ambiente en el que se esta desarrollando

  constructor(
    private parametroEmpresaService: ParametroEmpresaService,
    private messageRendererService: MessageRendererService
  ) { }

  init() {
    if (this.produccion) {
      this.rutEmpresa = Number(this.getRutEmpresa());
      console.log('Rut empresa', this.rutEmpresa);
      if (this.rutEmpresa && this.rutEmpresa != 0) {
        this.parametroEmpresaService.obtenerUrlNegociador(this.rutEmpresa, ({ respuesta, mensajes }) => {
          if (mensajes && mensajes.length > 0) {
            this.messageRendererService.showErrors(mensajes)
            return
          }
          const urlNegociador = respuesta.valor
          this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(urlNegociador)
            .configureLogging(signalR.LogLevel.Information)
            .build();

          this.hubConnection.start().catch(err => console.error(err.toString()));

          this.hubConnection.on('notify', (data: any) => {
            console.log('NOTIFICACIONES RECIBIDAS', data);
            if (!data) return;
            this.handleMessage(data[0]);
          });

          this.hubConnection.onclose((error) => {
            console.log('Conexión cerrada con error: ' + error);
          });
        })
      }
    } else {

      const urlNegociador = 'http://localhost:7048/api'
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(urlNegociador)
        .configureLogging(signalR.LogLevel.Information)
        .build();

      this.hubConnection.start().catch(err => console.error(err.toString()));

      this.hubConnection.on('notify', (data: any) => {
        console.log('NOTIFICACIONES RECIBIDAS', data);
        if (!data) return;
        this.handleMessage(data[0]);
      });

      this.hubConnection.onclose((error) => {
        console.log('Conexión cerrada con error: ' + error);
      });
    }
  }

  private handleMessage(data: string) {
    this.eliminarProcesoSignal(data);
    // const normalized = this.normalizeAndFilter(data);
    this.messages.next(data);
  }

  // Normaliza a string JSON y filtra estado_notificacion_codigo == 1
  private normalizeAndFilter(data: any): string {
    try {
      const arr = Array.isArray(data) ? data : JSON.parse(typeof data === 'string' ? data : JSON.stringify(data));
      const onlyActivas = (arr || []).filter(
        (x: any) => x.estado_notificacion_codigo != 3
      );
      console.log('NOTIFICACIONES RECIBIDAS ACTIVAS', arr);
      return JSON.stringify(onlyActivas);
    } catch (e) {
      console.error('Error normalizando notificaciones SignalR:', e);
      // Retornar el original
      return typeof data === 'string' ? data : JSON.stringify(data);
    }
  }

  private eliminarProcesoSignal(data: any) {
    try {
      const arr = typeof data === 'string' ? JSON.parse(data) : data;
      console.log('Eliminar proceso signal', arr);
      arr.forEach((item: any) => {
        const tipo = item.tipo_notificacion_codigo;
        const categoria = item.categoria_modulo_codigo;
        const id = `${tipo}_${categoria}`;
        console.log('Eliminar proceso signal', `processSignal${id}`);
        sessionStorage.removeItem(`processSignal${id}`);
      });
    } catch {
      // Si llega un array u otro formato, no se puede inferir la key; no eliminar.
    }
  }

  private getRutEmpresa(): any {
    return localStorage.getItem(StorageVariable.RUT_EMPRESA);
  }
}
